import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-debug-badge',
    templateUrl: './debug-badge.component.html',
    styleUrls: ['./debug-badge.component.scss'],
    standalone: false
})
export class DebugBadgeComponent {
  @Input() isDebugMode: boolean = false;
  @Input() badgeColor: string = '#22979d';
}
